function money(value) {
    return Math.round(value * 100) / 100;
}
export function summariseStatement(lines, revenueShareBps) {
    var _a;
    const byCurrency = new Map();
    for (const line of lines) {
        const currency = (line.currency || "").toUpperCase();
        if (!currency)
            continue;
        const bucket = (_a = byCurrency.get(currency)) !== null && _a !== void 0 ? _a : {
            gross: 0,
            reversed: 0,
            invoiced: 0,
        };
        if (line.status === "invoiced")
            bucket.invoiced += line.amount;
        else if (line.amount < 0)
            bucket.reversed += -line.amount;
        else
            bucket.gross += line.amount;
        byCurrency.set(currency, bucket);
    }
    return [...byCurrency.entries()]
        .map(([currency, bucket]) => {
        const net = bucket.gross - bucket.reversed;
        return {
            currency,
            gross: money(bucket.gross),
            reversed: money(bucket.reversed),
            net: money(net),
            invoiced: money(bucket.invoiced),
            ownerShare: revenueShareBps === null
                ? null
                : money((net * revenueShareBps) / 10000),
            nendaShare: revenueShareBps === null
                ? null
                : money(money(net) - money((net * revenueShareBps) / 10000)),
        };
    })
        .sort((a, b) => a.currency.localeCompare(b.currency));
}
export function inStatementPeriod(at, from, to) {
    const t = Date.parse(at);
    if (!Number.isFinite(t))
        return false;
    return t >= from.getTime() && t < to.getTime();
}
export function statementToCsv(statement) {
    const header = [
        "at",
        "kind",
        "status",
        "ref",
        "description",
        "assetIds",
        "amount",
        "currency",
        "reversal",
        "paymentRef",
    ];
    const cell = (value) => `"${String(value).replace(/"/g, '""')}"`;
    const rows = statement.lines.map((line) => {
        var _a, _b;
        return [
            line.at,
            line.kind,
            line.status,
            line.ref,
            (_a = line.description) !== null && _a !== void 0 ? _a : "",
            line.assetIds.join(" "),
            line.amount,
            line.currency,
            line.reversal,
            (_b = line.paymentRef) !== null && _b !== void 0 ? _b : "",
        ]
            .map(cell)
            .join(",");
    });
    return [header.map(cell).join(","), ...rows].join("\n");
}
